import { Dialog } from "@ariakit/react";
import {
  AuthCard,
  MiddotSeparated,
  MinWidth,
  useAppActions,
  useCurrentUser,
  useMediaQuery,
} from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import { Link } from "wouter";
import { navLinks, NavLinkUsage } from "../DashboardPage/navLinks.ts";
import { NavLink } from "./Layout.tsx";
import { useSidenavStore } from "./SidenavContext.tsx";
import logo from "./spacegitsLogoSquare.png";
import { sidenav } from "./style.css.ts";
import { useCloseOnInteract } from "./useCloseOnInteract.tsx";

export function Sidenav() {
  const { logout } = useAppActions();
  const store = useSidenavStore();
  const currentUser = useCurrentUser();
  const isMediumOrWider = useMediaQuery(MinWidth.MEDIUM);

  // Within the sidenav, if the user clicks an interactive element like an
  // anchor or a button, the sidenav should close.
  const closeOnInteractiveElementClick = useCloseOnInteract(store);

  return (
    <Dialog
      store={store}
      modal={!isMediumOrWider}
      className={sidenav.container}
      onClick={closeOnInteractiveElementClick}
    >
      <Link href="~/" className={sidenav.logoLink}>
        <img src={logo} alt="Space Gits" className={sidenav.logo} />
      </Link>

      <div className={sidenav.links}>
        {navLinks
          .filter((link) => !!(link.usage & NavLinkUsage.SIDEBAR))
          .map((link) => {
            return <NavLink {...link} key={link.href} />;
          })}
      </div>

      <div className={sidenav.info}>
        <div>Ruleset v1.4.0 (demo)</div>

        <MiddotSeparated>
          <Link className={interactiveText} href="~/settings">
            Settings
          </Link>

          <Link className={interactiveText} href="~/docs/help/about">
            About
          </Link>
        </MiddotSeparated>
      </div>

      <AuthCard onLogout={logout} currentUser={currentUser} />
    </Dialog>
  );
}
